module.exports = __webpack_public_path__ + "img/H-63-ST-1200-N.850aa47e.png";